import { render, staticRenderFns } from "./TechnicalDataForm.vue?vue&type=template&id=a2d5115c&scoped=true"
import script from "./TechnicalDataForm.vue?vue&type=script&lang=ts"
export * from "./TechnicalDataForm.vue?vue&type=script&lang=ts"
import style0 from "./TechnicalDataForm.vue?vue&type=style&index=0&id=a2d5115c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d5115c",
  null
  
)

export default component.exports